import React, { memo } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';
import { EmailIcon, PackageIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { FormDeliveryChannelType } from 'constants/loanApplication';

import { DisclosureDeliveryTestIds } from '../../DisclosureDelivery.testIds';

const CHANNEL_CONFIG = {
  [FormDeliveryChannelType.MAIL]: {
    label: 'Mail',
    Icon: PackageIcon,
    tooltip: 'Delivered by physical mail',
  },
  [FormDeliveryChannelType.EMAIL]: {
    label: 'Email',
    Icon: EmailIcon,
    tooltip: 'Delivered by email',
  },
};

// Recipients created before DEV-4796 (or any request type this hasn't been extended to) carry no
// `channel` at all — default that to Email, the only channel that existed until now.
const ChannelBadge = ({ channel }) => {
  const { label, Icon, tooltip } =
    CHANNEL_CONFIG[channel] ?? CHANNEL_CONFIG[FormDeliveryChannelType.EMAIL];

  return (
    <Tooltip arrow title={tooltip}>
      <Box
        className="flex items-center gap-4"
        data-testid={DisclosureDeliveryTestIds.CHANNEL_BADGE}
      >
        <Icon size={12} />
        <Typography color="text.secondary" variant="regular12">
          {label}
        </Typography>
      </Box>
    </Tooltip>
  );
};

ChannelBadge.propTypes = {
  channel: PropTypes.oneOf(Object.values(FormDeliveryChannelType)),
};

export default memo(ChannelBadge);
